import { CountryDictionaryItem } from '@/models/dictionary/country';
import { ICountryDictionaryApi } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';

export const useAllowedCountryDictionary = defineStore('allowedCountryDictionary', () => {
    const items = shallowRef<CountryDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: ICountryDictionaryApi[]) {
        console.time('set-allowedCountry-dictionary');
        items.value = data.map((item) => new CountryDictionaryItem(item));
        console.timeEnd('set-allowedCountry-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
